import { createSlice } from "@reduxjs/toolkit";

export const reports = createSlice({
  name: "reportTabs",
  initialState: {
    activeTabs: "purchaseRequest",
  },

  reducers: {
    updateReportTabs: (state = reports?.initialState, action) => {
      state.activeTabs = action.payload;
    },
  },
});
export const { updateReportTabs } = reports.actions;
export default reports.reducer;
